import React from 'react';
import loadable from '@loadable/component';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Loader } from '../../../../common/components';
// Routes
const ListSourcesPage = loadable(() => import('./ListSourcesPage'), {
  fallback: <Loader />
});
const AddSourcesPage = loadable(() => import('./AddSourcesPage'), {
  fallback: <Loader />
});
const EditSourcesPage = loadable(() => import('./EditSourcesPage'), {
  fallback: <Loader />
});
const SourcesRoute = ({ t, alert }) => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListSourcesPage t={t} alert={alert} />} />
      <Route exact path="/add" element={<AddSourcesPage t={t} alert={alert} />} />
      <Route exact path="/edit/:id" element={<EditSourcesPage t={t} alert={alert} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
SourcesRoute.propTypes = {
  t: PropTypes.func
};
export default SourcesRoute;
